export interface HomebuyerPathIcon {
  withAccent?: boolean
}

export const PrimaryStrokeColor = "currentColor"
export const AccentStrokeColor = "#4697A4"
